import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'


class DetailBloc {

    acDataChannel = new Subject();
    acDetailChannel = new Subject();
    stankomChannel = new Subject();
    acMatrixChannel = new Subject();
    devGuideChannel = new Subject();
    SuitablePossitionChannel = new Subject();
    repository = new DetailRepository()

    constructor() {
        this.acDataChannel.next({status: apiResponse.INITIAL})
        this.acDetailChannel.next({status: apiResponse.INITIAL})
        this.stankomChannel.next({status: apiResponse.INITIAL})
        this.SuitablePossitionChannel.next({status: apiResponse.INITIAL})
    }

    fetchAcData = async (query) => {
       try {
           this.acDataChannel.next({status: apiResponse.LOADING})
           await this.repository.fetchAcData(query).then((result) => {
               this.acDataChannel.next({status: apiResponse.COMPLETED, data: result})
           }).catch((error) => {
               this.acDataChannel.next({status: apiResponse.ERROR, data: error})
           })
       } catch (error) { console.log("unsubscribed")}
    }
    fetchAcDetail = async (query) => {
        this.acDetailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchAcDetail(query).then((result) => {
            this.acDetailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.acDetailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchStankom = async (query) => {
        this.stankomChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchStankom(query).then((result) => {
            this.stankomChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.stankomChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchMatrix = async (query) => {
        this.acMatrixChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchMatrix(query).then((result) => {
            this.acMatrixChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.acMatrixChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDevGuide = async (query) => {
        this.devGuideChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDevGuide(query).then((result) => {
            this.devGuideChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.devGuideChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchSuitablePossision = async (query) => {
        this.SuitablePossitionChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSuitablePossision(query).then((result) => {
            this.SuitablePossitionChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.SuitablePossitionChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default DetailBloc